<script setup lang="ts">
withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: "#0F8577",
  },
);
</script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.899 6.97571C17.1326 6.75334 17.4434 6.63041 17.7659 6.63285C18.0884 6.63529 18.3973 6.76291 18.6275 6.98879C18.8576 7.21466 18.9911 7.52112 18.9996 7.8435C19.0081 8.16588 18.8911 8.47896 18.6731 8.71669L12.0574 16.9905C11.9437 17.113 11.8064 17.2113 11.6537 17.2796C11.5011 17.3478 11.3363 17.3846 11.1691 17.3877C11.0019 17.3908 10.8359 17.3602 10.6808 17.2976C10.5258 17.2351 10.3849 17.1419 10.2667 17.0236L5.87944 12.6364C5.75726 12.5225 5.65926 12.3852 5.5913 12.2327C5.52333 12.0802 5.48678 11.9155 5.48384 11.7485C5.48089 11.5815 5.51161 11.4157 5.57415 11.2608C5.63669 11.106 5.72979 10.9653 5.84787 10.8472C5.96596 10.7292 6.10662 10.6361 6.26146 10.5735C6.41631 10.511 6.58216 10.4803 6.74914 10.4832C6.91611 10.4862 7.08078 10.5227 7.23332 10.5907C7.38586 10.6586 7.52315 10.7566 7.637 10.8788L11.109 14.3492L16.8675 7.01219C16.8779 6.99942 16.8889 6.98724 16.9007 6.97571H16.899Z"
      fill="url(#paint0_linear_11041_143401)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11041_143401"
        x1="5.48364"
        y1="12.0108"
        x2="19.0008"
        y2="12.0108"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9681DB" />
        <stop offset="1" stop-color="#79BAC0" />
      </linearGradient>
    </defs>
  </svg>
</template>
